// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
import { ErrorsFragmentDoc } from './UpdateUserSettingsMutation';
export type LoginMutationVariables = Exact<{
  username: string;
  password: string;
  site: string;
  otp?: string | null | undefined;
  captcha?: string | null | undefined;
  captchaVersion?: string | null | undefined;
  language?: string | null | undefined;
  domain?: string | null | undefined;
  authClearanceId?: string | null | undefined;
}>;


export type LoginMutation = { userManagementLoginViaPassword: { sessionId: string | undefined, token: string | undefined, deviceDataToken: string | undefined, userManagement: { currentUser: { username: string | undefined, email: string | undefined } | undefined, currentProfile: { _id: string | undefined } | undefined } | undefined, errors: Array<{ message: string | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };


export const LoginMutationDocument = gql`
    mutation LoginMutation($username: String!, $password: String!, $site: String!, $otp: String, $captcha: String, $captchaVersion: String, $language: String, $domain: String, $authClearanceId: String) {
  userManagementLoginViaPassword(
    input: {
      site: $site
      username: $username
      password: $password
      otp: $otp
      captcha: $captcha
      captchaVersion: $captchaVersion
      language: $language
      domain: $domain
      authClearanceId: $authClearanceId
    }
  ) {
    sessionId
    token
    userManagement {
      currentUser {
        username
        email
      }
      currentProfile {
        _id
      }
    }
    deviceDataToken
    errors {
      ...ErrorsFragment
    }
  }
}
    ${ErrorsFragmentDoc}`;